/**
 * listingTypeHelpers.js
 *
 * Single source of truth for Famous Global listing type classification.
 *
 * There are exactly 3 Famous Global custom listing type IDs:
 *
 *   tour-activity       -> Custom MongoDB Slot Flow  (Single Day Experience, unitType: fixed)
 *   tour-activity-multi -> Custom MongoDB Slot Flow  (Multi-Day Experience, unitType: day)
 *   group-travel        -> Purchase Flow             (Group Trip, purchase process, finite stock)
 *
 * EVERYTHING ELSE uses the default Sharetribe approach:
 *   hourly-booking, nightly-booking, daily-booking, fixed-booking, or any other listingType
 *   -> Standard WeeklyCalendar availability, standard booking forms, standard line items.
 *
 * Detection is always by listingType ID, NOT by unitType alone, because
 * tour-activity-multi uses unitType:'day' but is NOT a standard Sharetribe day booking.
 */

// Custom MongoDB Slot Flow listing type IDs
export const CUSTOM_SLOT_LISTING_TYPES = [
  'tour-activity',            // Single Day Experience (unitType: fixed)
  'tour-activity-multi',      // Multi-Day Experience  (unitType: day, but custom slot flow)
  // 'group-travel-custom-flow', // Group travel           (unitType: fixed, custom slot flow)
  // 'custom-flow',              // One-time experience    (unitType: fixed, custom slot flow)
];

// Purchase / Group Travel Flow - exactly this one ID
export const PURCHASE_FLOW_LISTING_TYPES = [
  'group-travel', // Group Trip (purchase process, finite stock, multiple items)
];

/**
 * Returns true ONLY for tour-activity and tour-activity-multi.
 * All other listing types return false and fall through to the default Sharetribe approach.
 *
 * @param {string} listingType - listing.attributes.publicData.listingType
 * @returns {boolean}
 */
export const isCustomSlotFlow = listingType =>
  CUSTOM_SLOT_LISTING_TYPES.includes(listingType);

/**
 * Returns true ONLY for group-travel.
 *
 * @param {string} listingType
 * @returns {boolean}
 */
export const isPurchaseFlowType = listingType =>
  PURCHASE_FLOW_LISTING_TYPES.includes(listingType);

/**
 * Returns true for every listing that is NOT a Famous Global custom type.
 * This is the default Sharetribe path.
 *
 * @param {string} listingType
 * @returns {boolean}
 */
export const isDefaultSharetribeFlow = listingType =>
  !CUSTOM_SLOT_LISTING_TYPES.includes(listingType) &&
  !PURCHASE_FLOW_LISTING_TYPES.includes(listingType);
